import OrderRow from './orderrow';
import Location from './location';
import Customer from './customer';
import Address from './address';
import ElectronicInvoiceInfo from './electronicinvoiceinfo';
import { orderStatusToText } from './orderstatus';

class ProductionOrder {
    constructor(json) {
        if (json != null) {
            this.orderNumber = json.orderNumber;
            this.publicReference = json.publicReference;
            this.status = json.status;
            this.orderItems = [];
            if (json.orderItems != null && json.orderItems.length > 0) {
                for (let orderItem of json.orderItems) {
                    this.orderItems.push(new ProductionOrderItem(orderItem));
                }
            }
            if (json.customer != null) {
                this.customer = new Customer(json.customer);
            }
            this.orderTotalPrice = json.orderTotalPrice;
            this.orderTotalPriceWithoutVat = json.orderTotalPriceWithoutVat;
            this.orderTotalVatAmount = json.orderTotalVatAmount;
            this.deliveryTime = json.deliveryTime;
            this.deliveryTerms = json.deliveryTerms;
            this.ordererName = json.ordererName;
            this.ordererTel = json.ordererTel;
            this.contractNumber = json.contractNumber;
            this.deliveryRecipient = json.deliveryRecipient;
            if (json.deliveryAddress) this.deliveryAddress = new Address(json.deliveryAddress);
            this.deliveryCustomerNumber = json.deliveryCustomerNumber;
            this.billingResponsible = json.billingResponsible;
            if (json.billingAddress) this.billingAddress = new Address(json.billingAddress);
            if (json.electronicInvoiceAddress)
                this.electronicInvoiceAddress = new ElectronicInvoiceInfo(json.electronicInvoiceAddress);
            this.billingResponsibleBusinessId = json.billingResponsibleBusinessId;
            this.billingResponsibleCustomerNumber = json.billingResponsibleCustomerNumber;
            this.billingTerms = json.billingTerms;
            this.orderSent = json.orderSent;
            this.orderForm = json.orderForm;
            this.reference = json.reference;
            this.confirmationEmail = json.confirmationEmail;
            this.orderSender = json.orderSender;
            this.portfolioId = json.portfolioId;
            this.maintenanceArea = json.maintenanceArea;
            this.packingInstructions = json.packingInstructions;
            this.invoiceNumbers = json.invoiceNumbers;
            this.deliveryMethod = json.deliveryMethod;
            this.deliveryInfo = json.deliveryInfo;
            this.emailInvoiceAddress = json.emailInvoiceAddress;
            this.invoicingInfoBase64 = json.invoicingInfoBase64;

            // Sweden expansion -- see doc/sweden-expansion-currency-plan.md.
            this.tenantCompanyId = json.tenantCompanyId;
            this.currency = json.currency;
        }
    }
    static OrderStatusOrdered() {
        return 4;
    }
    static OrderStatusInProduction() {
        return 5;
    }
    static OrderStatusPacked() {
        return 6;
    }
    static OrderStatusLoaded() {
        return 7;
    }
    static OrderStatusDelivered() {
        return 8;
    }
    static StatusDeliveredNonInvoicable() {
        return 9;
    }
    orderStatusText() {
        return orderStatusToText(this.status);
    }
    // Display-only helper, see Order.getDisplayOrderNumber for details.
    getDisplayOrderNumber() {
        return this.publicReference || this.orderNumber;
    }
    getDeliveryInfo() {
        return this.deliveryAddress != null
            ? `${this.deliveryRecipient}, ${this.deliveryAddress.streetAddress}, ${this.deliveryAddress.zipCode} ${this.deliveryAddress.city}`
            : null;
    }
    getBillingAddressInfo() {
        return this.billingAddress != null
            ? `${this.billingResponsible}, ${this.billingAddress.streetAddress}, ${this.billingAddress.zipCode} ${this.billingAddress.city}`
            : null;
    }
    getElectronicInvoiceAddressInfo() {
        return this.electronicInvoiceAddress != null
            ? `${this.electronicInvoiceAddress.ovt}, ${this.electronicInvoiceAddress.operatorBrokerId}, ${this.electronicInvoiceAddress.operator}`
            : null;
    }
}

class ProductionOrderItem {
    constructor(json) {
        if (json != null) {
            this.id = json.id;
            this.storageId = json.storageId;
            this.location = json.location ? new Location(json.location) : null;
            this.orderTotalPrice = json.orderTotalPrice;
            this.orderTotalPriceWithoutVat = json.orderTotalPriceWithoutVat;
            this.vatAmount = json.vatAmount;
            this.vatPercent = json.vatPercent;
            this.deliveryRecipient = json.deliveryRecipient;
            this.orderedFilters = [];
            if (json.orderedFilters != null && json.orderedFilters.length > 0) {
                for (let f of json.orderedFilters) {
                    this.orderedFilters.push(new OrderRow(f));
                }
            }
        }
    }
}

export default ProductionOrder;
